import createLucideIcon from '../createLucideIcon';

const ArrowRightSquare = createLucideIcon('ArrowRightSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '12,16 16,12 12,8', key: 'k66ntr' }],
  ['line', { x1: '8', x2: '16', y1: '12', y2: '12', key: '1jonct' }],
]);

export default ArrowRightSquare;
